import _map from 'lodash/map';
import _property from 'lodash/property';
import { EMPTY_ARRAY } from '../app.constants';
import { TABLE_ITEMS_LOADING, TABLE_ITEMS_RECEIVE, TABLE_ITEMS_UPDATED, TABLE_ITEMS_DELETED, TABLE_ITEMS_PAGE_UPDATE, TABLE_ITEMS_SET_FILTER, TABLE_ITEMS_SET_SEARCH_QUERY, TABLE_ITEMS_SORT_APPLIED, TABLE_ITEMS_ADDED, TABLE_ITEMS_CLEAR, TABLE_ITEMS_UPDATE_COUNT, TABLE_FILTER_LOADING, TABLE_ITEMS_SET_PAGE_ROW, TABLE_FILTER_RECEIVE, TABLE_ITEMS_LOADING_ERROR, TABLE_ITEMS_FILTER_RECEIVE, TABLE_ITEMS_SET_ADDITIONAL_DATA, TABLE_ITEMS_SET_SCROLL_STATE, TABLE_REMOVE_EXTRA_ITEMS, TABLE_ITEMS_CLEAR_IDS, TABLE_ITEMS_SET_GROUP_BY, TABLE_ITEMS_CLEAR_ADDITIONAL_DATA, TABLE_RESET_TO_INITIAL_STATE } from '../constants/tableItemActions';
export function getLoadingItemsAction(itemType, _ref) {
  var filterValue = _ref.filterValue,
      pageInfo = _ref.pageInfo,
      pageNumber = _ref.pageNumber,
      isScroll = _ref.isScroll,
      _ref$selectedFilters = _ref.selectedFilters,
      selectedFilters = _ref$selectedFilters === void 0 ? EMPTY_ARRAY : _ref$selectedFilters;
  return {
    type: TABLE_ITEMS_LOADING,
    itemType: itemType,
    filterValue: filterValue,
    pageInfo: pageInfo,
    pageNumber: pageNumber,
    isScroll: isScroll,
    selectedFilters: selectedFilters
  };
}
export function getPageRowAction(itemType, _ref2) {
  var filterValue = _ref2.filterValue,
      rows = _ref2.rows;
  return {
    type: TABLE_ITEMS_SET_PAGE_ROW,
    rows: rows,
    itemType: itemType,
    filterValue: filterValue
  };
}
export function getSaveItemsAction(items, _ref3) {
  var itemType = _ref3.itemType,
      filterValue = _ref3.filterValue,
      totalCount = _ref3.totalCount,
      _ref3$idGetter = _ref3.idGetter,
      idGetter = _ref3$idGetter === void 0 ? _property('id') : _ref3$idGetter,
      pageNumber = _ref3.pageNumber,
      hasMore = _ref3.hasMore,
      groups = _ref3.groups,
      nextPageToken = _ref3.nextPageToken;
  return {
    type: TABLE_ITEMS_RECEIVE,
    ids: _map(items, idGetter),
    items: items,
    itemType: itemType,
    totalCount: totalCount,
    filterValue: filterValue,
    pageNumber: pageNumber,
    hasMore: hasMore,
    groups: groups,
    nextPageToken: nextPageToken
  };
}
export var getRemoveExtraItemsAction = function getRemoveExtraItemsAction(_ref4) {
  var itemType = _ref4.itemType,
      filterValue = _ref4.filterValue;
  return {
    type: TABLE_REMOVE_EXTRA_ITEMS,
    itemType: itemType,
    filterValue: filterValue
  };
};
export function getSetItemsFiltersAction(selectedFilters, _ref5) {
  var itemType = _ref5.itemType,
      filterValue = _ref5.filterValue;
  return {
    type: TABLE_ITEMS_FILTER_RECEIVE,
    itemType: itemType,
    filterValue: filterValue,
    selectedFilters: selectedFilters
  };
}
export function getClearItemsAction(itemType) {
  return {
    type: TABLE_ITEMS_CLEAR_IDS,
    itemType: itemType
  };
}
export function getAddItemsAction(items, _ref6) {
  var itemType = _ref6.itemType,
      filterValue = _ref6.filterValue,
      totalCount = _ref6.totalCount,
      _ref6$idGetter = _ref6.idGetter,
      idGetter = _ref6$idGetter === void 0 ? _property('id') : _ref6$idGetter;
  return {
    type: TABLE_ITEMS_ADDED,
    ids: _map(items, idGetter),
    items: items,
    itemType: itemType,
    totalCount: totalCount,
    filterValue: filterValue
  };
}
export function getUpdateItemsAction(items, _ref7) {
  var itemType = _ref7.itemType;
  return {
    type: TABLE_ITEMS_UPDATED,
    items: items,
    itemType: itemType
  };
}
export function getDeleteItemsAction(ids, _ref8) {
  var itemType = _ref8.itemType;
  return {
    type: TABLE_ITEMS_DELETED,
    ids: ids,
    itemType: itemType
  };
}
export function getSetFilterAction(filterValue, _ref9) {
  var itemType = _ref9.itemType;
  return {
    type: TABLE_ITEMS_SET_FILTER,
    itemType: itemType,
    filterValue: filterValue
  };
}
export function getUpdatePageAction(pageNumber, _ref10) {
  var itemType = _ref10.itemType,
      filterValue = _ref10.filterValue;
  return {
    type: TABLE_ITEMS_PAGE_UPDATE,
    itemType: itemType,
    pageNumber: pageNumber,
    filterValue: filterValue
  };
}
export function getUpdateScrollState(scrollState, _ref11) {
  var itemType = _ref11.itemType;
  return {
    type: TABLE_ITEMS_SET_SCROLL_STATE,
    itemType: itemType,
    scrollState: scrollState
  };
}
export function getSetSearchQueryAction(searchQuery, _ref12) {
  var itemType = _ref12.itemType,
      searchField = _ref12.searchField;
  return {
    type: TABLE_ITEMS_SET_SEARCH_QUERY,
    itemType: itemType,
    searchQuery: searchQuery,
    searchField: searchField
  };
}
export function getSetSortAction(sortDetails, _ref13) {
  var itemType = _ref13.itemType;
  return {
    type: TABLE_ITEMS_SORT_APPLIED,
    itemType: itemType,
    sortDetails: sortDetails
  };
}
export function getSaveFilterAction(filters, _ref14) {
  var itemType = _ref14.itemType;
  return {
    type: TABLE_FILTER_RECEIVE,
    itemType: itemType,
    filters: filters
  };
}
export function getLoadingFilterAction(itemType, _ref15) {
  var filterValue = _ref15.filterValue;
  return {
    type: TABLE_FILTER_LOADING,
    itemType: itemType,
    filterValue: filterValue
  };
}
export function getClearAction(itemType) {
  return {
    type: TABLE_ITEMS_CLEAR,
    itemType: itemType
  };
}
export function getAdditionalDataClearAction(itemType) {
  return {
    type: TABLE_ITEMS_CLEAR_ADDITIONAL_DATA,
    itemType: itemType
  };
}
export function getTableResetToInitialState(itemType) {
  return {
    type: TABLE_RESET_TO_INITIAL_STATE,
    itemType: itemType
  };
}
export function setTableTotalCount(itemType, totalCount) {
  return {
    type: TABLE_ITEMS_UPDATE_COUNT,
    itemType: itemType,
    totalCount: totalCount
  };
}
export function getErrorItemsAction(itemType, _ref16) {
  var filterValue = _ref16.filterValue,
      pageInfo = _ref16.pageInfo,
      pageNumber = _ref16.pageNumber;
  return {
    type: TABLE_ITEMS_LOADING_ERROR,
    itemType: itemType,
    filterValue: filterValue,
    pageInfo: pageInfo,
    pageNumber: pageNumber
  };
}
export function getSetAdditionalDataAction(itemType, _ref17) {
  var additional = _ref17.additional;
  return {
    type: TABLE_ITEMS_SET_ADDITIONAL_DATA,
    itemType: itemType,
    additional: additional
  };
}
export function getSetGroupByAction(itemType, groupBy) {
  return {
    type: TABLE_ITEMS_SET_GROUP_BY,
    itemType: itemType,
    groupBy: groupBy
  };
}